import React, {useEffect, useState} from "react";
import {SigninForm} from "../molecules/SigninForm";
import Button from "@mui/material/Button";
import PdfUpload from "./PdfUpload";
import axios from "axios";
import {getAxiosBaseUrl, getBaseUrlNodeServer, getGisBaseUrl} from "../../config";
import './myapplication.css'
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import {MapContainer, Marker, Rectangle, TileLayer, useMap} from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import icon from "../../assets/userIcon.png";
import DiscreteSliderValues from "./DiscreteSliderValues";
import * as jobUtils from "./jobUtils";

const customIcon = new L.Icon({
	iconUrl: icon, // URL to your custom icon
	iconSize: [25, 41], // Size of the icon
	iconAnchor: [12, 41], // Point of the icon which will correspond to marker's location
	popupAnchor: [1, -34], // Point from which the popup should open relative to the iconAnchor
	// shadowUrl: 'path_to_your_icon_shadow.png', // Optional shadow image
	// shadowSize: [41, 41]
});

export default function MyApplications() {
	const gisUsername = 'nominatim';
	const gisPassword = 'utegis2!';
	var signedin = sessionStorage.getItem("signedin");
	const [pdfUrl, setPdfUrl] = useState('');
	const [pdfText, setpdfText] = useState('');
	const [matchedJobs, setMatchedJobs] = useState([]);
	const [skillText, setSkillText] = useState('');
	const [experienceText, setexperienceText] = useState('');
	const [educationText, seteducationText] = useState('');
	const [pdfData, setPdfData] = useState(null);
	const [pdfNamesAndIds, setpdfNamesAndIds] = useState(null);
	const [currentPdfName, setcurrentPdfName] = useState('');
	const [currentPdfId, setcurrentPdfId] = useState('');
	const [ipLatLongLocations, setipLatLongLocations] = useState([]);
	const [query, setQuery] = useState('95050');
	const [gisDataArr, setgisDataArr] = useState([]);
	const [miles, setmiles] = useState(20);
	const [bbox, setbbox] = useState([[37.3331279618023, -122.07153696569458], // Southwest corner
		[37.35838814165478, -122.03975737931526] // Northeast corner
	]);
	
	function loadPdfFile(rec) {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getPdf/' + rec._id, {responseType: 'blob'}).then(response => {
			const pdfBlob = new Blob([response.data], {type: 'application/pdf'});
			const pdfUrl = URL.createObjectURL(pdfBlob);
			setPdfUrl(pdfUrl);
		})
		setcurrentPdfName(rec.filename)
		setcurrentPdfId(rec._id)
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getPdfText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setpdfText(response.data);
		});
		
		axios.defaults.baseURL = getAxiosBaseUrl()
		axios.get('/getMatchedJobs/' + rec._id).then(response => {
			// console.log(response.data)
			setMatchedJobs(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getSkillText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setSkillText(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getExperienceText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setexperienceText(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getEducationText/' + rec._id).then(response => {
			seteducationText(response.data);
		});
	}
	function loadPdfText(pdfId) {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getPdfText/' + pdfId).then(response => {
			setpdfText(response.data);
		})
	}
	
	function getBoundingBox(lat, lng, distanceInMiles) {
		const earthRadius = 3958.8;
		
		// Distance in degrees = Distance in radians * (180 / PI)
		const distanceInDegreesLat = (distanceInMiles / earthRadius) * (180 / Math.PI);
		
		// Correction for longitude distance calculation
		const radiusAtLat = earthRadius * Math.cos(lat * Math.PI / 180);
		const distanceInDegreesLng = (distanceInMiles / radiusAtLat) * (180 / Math.PI);
		
		// Calculate bounding box corners
		const north = lat + distanceInDegreesLat;
		const south = lat - distanceInDegreesLat;
		const east = lng + distanceInDegreesLng;
		const west = lng - distanceInDegreesLng;
		
		// Return SW and NE corners of the bounding box
		return [[south, west], [north, east]];
	}
	
	function getAndSetCurrentDistanceValue(miles) {
		// console.log('miles', miles)
		const newBbox = getBoundingBox(parseFloat(gisDataArr[0].lat), parseFloat(gisDataArr[0].lon), miles)
		setbbox(newBbox);
		setmiles(miles);
	}
	
	function handleSubmitQuery() {
		getGisData();
	}
	
	function handleAddressChange(e) {
		e.preventDefault();
		setQuery(e.target.value)
	}
	
	function RecenterMap({gisData}) {
		const map = useMap();
		
		React.useEffect(() => {
			if (gisData.length > 0) {
				const newCenter = [gisData[0].lat, gisData[0].lon];
				map.flyTo(newCenter, map.getZoom());
			}
		}, [gisData, map]); // Dependency array to trigger effect when gisData changes
		
		return null; // Component does not render anything
	}
	
	const FitBounds = ({bbox}) => {
		const map = useMap();
		
		useEffect(() => {
			if (!bbox || bbox.length !== 2) return; // Ensure bbox is correctly formatted
			
			// Convert string values to numbers if they are passed as strings
			const correctedBBox = bbox.map(point => [parseFloat(point[0]), parseFloat(point[1])]);
			
			// Fit map view to bounding box
			// map.fitBounds(correctedBBox);
			map.fitBounds(correctedBBox, {paddingTopLeft: [0, 0], paddingBottomRight: [0, 0]});
		}, [bbox, map]);
		
		// Draw the bounding box
		return <Rectangle bounds={bbox} color="lightskyblue"/>;
	};
	
	function getGisData() {
		axios.defaults.baseURL = getGisBaseUrl();
		// console.log('query ', axios.defaults.baseURL + '/search.php?q=' + query)
		axios.get('/search.php?q=' + query, {
			auth: {
				username: gisUsername,
				password: gisPassword
			}
		}).then(response => {
			const gisDataArr = response.data
			setgisDataArr(gisDataArr);
			const newBbox = getBoundingBox(parseFloat(gisDataArr[0].lat), parseFloat(gisDataArr[0].lon), miles)
			setbbox(newBbox);
		}).catch(error => {
			if (error.response) {
				console.log("Error data:", error.response.data);
				console.log("Error status:", error.response.status);
				console.log("Error headers:", error.response.headers);
			} else if (error.request) {
				console.log("No response received:", error.request);
			} else {
				console.log('Error', error.message);
			}
			console.log("Config:", error.config);
		});
	}
	
	function getAllPdfData() {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getAllPdfs').then(response => {
			setpdfNamesAndIds(response.data)
			if (response.data.length > 0) {
				loadPdfFile(response.data[0])
			}
		})
	}
	
	// useEffect(() => {
	// 	loadPdfText(currentPdfId);
	// }, [pdfText]);
	
	useEffect(() => {
		getAllPdfData();
		getGisData();
		
	}, []);
	
	function deletePdfFromDb(rec) {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/deletePdf/' + rec._id).then(response => {
			getAllPdfData();
			alert(response.data.message);
		})
	}
	
	function saveTextChangeToDb(e) {
		setpdfText(e.target.value);
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.post('/setPdfText/' + currentPdfId, {'newText': e.target.value})
	}
	
	function skillChangeEvent(e) {
		setSkillText(e.target.value);
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.post('/updateSkillText/' + currentPdfId, {'newText': e.target.value})
	}
	
	function experienceChangeEvent(e) {
		setexperienceText(e.target.value);
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.post('/updateExperienceText/' + currentPdfId, {'newText': e.target.value})
	}
	
	function educationChangeEvent(e) {
		seteducationText(e.target.value);
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.post('/updateEducationText/' + currentPdfId, {'newText': e.target.value})
	}
	
	function handleInputChange(e) {
		const localToken = e.target.value
		// setaccessToken(localToken); TODO make sure this is not a bad comment out
		// upsertToDb('userdata', {'email': sessionStorage.getItem("verifiedemail")}, {'shopifyStoreName': localToken})
	}
	
	const textStyle = {
		fontSize: '16px',
		fontWeight: 'bold',
		backgroundImage: 'linear-gradient(90deg, rgb(155, 66, 255), rgb(246, 75, 255), rgb(235, 123, 163))',
		WebkitBackgroundClip: 'text', // Note the camelCase and the Webkit prefix
		color: 'transparent',
		backgroundClip: 'text',
		// display: 'flex',
	};
	
	
	if (!signedin) {
		return <div style={{marginTop: "300px"}}>
			<SigninForm/>
		</div>
	} else {
		return (<div style={{marginTop: "0px", marginLeft: "0px", minHeight: "0px"}}>
			<div style={{marginTop: "5px"}}>
				<div style={{display: "flex", verticalAlign: "middle", alignItems: "center", marginTop: "10px"}}>
					<div style={{}}>Your Files:</div>
					<div style={{
						marginLeft: "10px",
						border: "1px solid lightgrey",
						marginTop: "10px",
						padding: "10px",
						borderRadius: "10px",
						maxHeight: "200px",
						overflowY: "scroll",
						marginRight: "20px"
					}}>
						{pdfNamesAndIds ? pdfNamesAndIds.map(rec => {
							return (<div style={{display: "flex"}}>
								<li className='pdfListItem' onClick={() => loadPdfFile(rec)}>
									{rec.filename}
								</li>
								<DeleteOutlined className='deleteButton' onClick={() => deletePdfFromDb(rec)}
								                style={{color: "lightskyblue", marginLeft: "40px"}}/>
							</div>)
						}) : <li>Loading Names...</li>}
					
					</div>
					<div style={{marginRight: "20px"}}>Add More Pdf Files / Resumes</div>
					<PdfUpload getAllPdfData={getAllPdfData}/>
				</div>
				
				<div style={{marginTop: "10px"}}>
					<div style={{marginBottom: "20px", marginTop: "10px", display: "flex", alignItems: "center"}}>
					</div>
					<div>
						<p style={{height: "30px", textAlign: "center", marginLeft: "-20px"}}>Selected File Name:
							<span style={{fontWeight: "bold", marginLeft: "10px"}}>{currentPdfName ? currentPdfName : ''}</span>
						</p>
						{pdfUrl ? (<div style={{display: "flex"}}>
							<div style={{marginRight: "10px", marginTop: "-20px"}}>
								<div style={textStyle}>Skills</div>
								<textarea onChange={(e) => skillChangeEvent(e)} style={{
									border: "1px solid lightgrey",
									height: "160px", borderRadius: "5px", padding: "10px", minWidth: "300px"
								}}
								          placeholder='Add Skills Here' value={skillText}/>
								<div style={textStyle}>Experience</div>
								<textarea style={{
									marginLeft: "0px",
									border: "1px solid lightgrey",
									height: "240px",
									borderRadius: "5px",
									padding: "10px",
									minWidth: "300px"
								}}
								          onChange={(e) => experienceChangeEvent(e)}
								          value={experienceText}
								          placeholder='Add Experience Text Here'/>
								<div style={textStyle}>Education</div>
								<textarea style={{
									marginLeft: "0px",
									border: "1px solid lightgrey",
									height: "100px",
									borderRadius: "5px",
									padding: "10px",
									minWidth: "300px"
								}}
								          onChange={(e) => educationChangeEvent(e)}
								          value={educationText}
								          placeholder='Add Education Text Here'/>
							</div>
							<textarea id='resumeText' style={{
								border: "1px solid black", borderRadius: "10px", width: '30%', height: '60vh', padding: "20px", marginRight: "10px"
							}} onChange={(e) => saveTextChangeToDb(e)}
							          value={pdfText}
							/>
							<iframe src={pdfUrl} style={{
								width: '50%', height: '60vh', borderRadius: "10px", border: "1px solid lightgrey", padding: "20px", paddingTop: "0px"
							}} frameBorder="0"></iframe>
						</div>) : (
							<p>Loading PDF...</p>)}
					</div>
				</div>
				
				<div style={{marginTop: "15px", alignItems: "center", display: "flex"}}>
				</div>
				{/*<div style={{marginTop: "10px"}}>*/}
				{/*	<input style={{*/}
				{/*		marginLeft: "10px", border: "1px solid lightgrey", height: "36px", borderRadius: "5px", padding: "10px"*/}
				{/*	}}*/}
				{/*	       placeholder='Update Keywords'/>*/}
				{/*	<input style={{*/}
				{/*		marginLeft: "10px", border: "1px solid lightgrey", height: "36px", borderRadius: "5px", padding: "10px"*/}
				{/*	}}*/}
				{/*	       placeholder='Add Locations'/>*/}
				{/*</div>*/}
			</div>
			<p style={{fontSize: "20px", fontWeight: "bold", marginTop: "0px"}}>Matched Jobs</p>
			<div style={{
				maxHeight: "700px", overflow: "scroll", border: "1px solid lightgrey", borderRadius: "10px",
				padding: "15px",
				fontSize: "14px"
			}}>
				<table style={{width: "100%"}}>
					<th style={{
						maxWidth: "30px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Row
					</th>
					<th style={{
						maxWidth: "100px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Job Url
					</th>
					<th style={{
						maxWidth: "80px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Company Name
					</th>
					<th style={{
						maxWidth: "200px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Title
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Date Posted
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Offsite Job
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Remote Job
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px", fontSize: "14px"
					}}>Locations
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px", fontSize: "14px"
					}}>Lat Longs
					</th>
					{matchedJobs.map((record, index) => {
						return (<tr key={index} style={{}}>
							<td style={{
								minWidth: "50px",
								textAlign: "center",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px"
							}}>{index + 1}</td>
							<td style={{
								minWidth: "50px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px"
							}}>
								<a href={record.jobUrl.trim()} target='_blank'>
									{record.jobUrl}
								</a>
							</td>
							<td style={{
								minWidth: "50px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.extractCompanyName(record.jobUrl)}
							</td>
							<td style={{
								minWidth: "200px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getTitleText(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey", borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getDatePosted(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.isOffsiteJob(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.isRemoteJob(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getLocationsInfo(record)}
							</td>
							<td style={{
								maxWidth: "200px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getLatLongs(record)}
							</td>
						</tr>)
					})}
				</table>
			</div>
			
			
			<br/><br/>
			<input id='campaignname' placeholder="Enter zipcode / city name / address here" onChange={handleAddressChange}
			       onKeyDown={(e) => {
				       if (e.key === 'Enter') {
					       handleSubmitQuery();
				       }
			       }}
			       style={{
				       lineHeight: 3,
				       textAlign: "center",
				       marginLeft: 10, marginBottom: "20px",
				       width: 300,
				       border: "1px solid gray",
				       borderRadius: "10px"
			       }}/>
			<Button variant='outlined' onClick={() => handleSubmitQuery()} style={{marginLeft: "50px"}}>Submit</Button>
			<MapContainer
				style={{
					height: "500px",
					width: "1000px",
				}}
				center={[37.34409429790077, -121.95347724990458]}
				zoom={12}
			>
				<TileLayer
					className="custom-opacity-tiles"
					attribution="Google Maps"
					url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
				/>
				{/*<TileLayer*/}
				{/*	className="custom-opacity-tiles"*/}
				{/*	attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
				{/*	url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
				{/*/>*/}
				{gisDataArr.map((record, index) => (
					<Marker key={index} position={[record.lat, record.lon]} icon={customIcon}/>
				))}
				<RecenterMap gisData={gisDataArr}/>
				<FitBounds bbox={bbox}/>
			</MapContainer>
			<DiscreteSliderValues getAndSetCurrentDistanceValue={getAndSetCurrentDistanceValue}/>
			<label>App. Driving Distance = {1.4 * miles} miles</label>
			{/*<MapContainer*/}
			{/*	style={{*/}
			{/*		height: "500px",*/}
			{/*		width: "1000px",*/}
			{/*	}}*/}
			{/*	center={gisDataArr.length > 0 ? [gisDataArr[0].lat, gisDataArr[0].lon] : [37.34409429790077, -121.95347724990458]}*/}
			{/*	zoom={12}>*/}
			{/*	<TileLayer*/}
			{/*		className="custom-opacity-tiles"*/}
			{/*		attribution="Google Maps"*/}
			{/*		url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"*/}
			{/*	/>*/}
			{/*	{gisDataArr.map((record, index) => (*/}
			{/*		<Marker key={index} position={[record.lat, record.lon]} icon={customIcon}/>*/}
			{/*	))}*/}
			{/*</MapContainer>*/}
			
			<p style={{fontSize: "20px", fontWeight: "bold", marginTop: "20px"}}>Custom Cover Letter for Every Job Generated With AI</p>
			<p style={{fontSize: "20px", fontWeight: "bold", marginTop: "20px"}}>Similar Jobs</p>
			<p style={{fontSize: "20px", fontWeight: "bold", marginTop: "20px"}}>Your Dashboard</p>
			<div style={{marginTop: "20px"}}>
				<Button variant='outlined'>Select Candidate</Button>
				<Button variant='outlined' style={{marginLeft: "10px"}}>Applied Jobs</Button>
				<Button variant='outlined' style={{marginLeft: "10px"}}> In Progress < /Button>
				<Button variant='outlined' style={{marginLeft: "10px"}}>Call back count</Button>
				<Button variant='outlined' style={{marginLeft: "10px"}}>Add Quota</Button>
			</div>
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
			{/*<div style={{marginTop: "20px"}}></div>*/}
			{/*<p style={{fontWeight: "bold"}}>My Queue</p>*/}
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
			{/*<div style={{marginTop: "20px"}}></div>*/}
			{/*<p style={{fontWeight: "bold"}}>Applied Jobs</p>*/}
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
			{/*<div style={{marginTop: "20px"}}></div>*/}
			{/*<p style={{fontWeight: "bold"}}>Discarded Jobs</p>*/}
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
		</div>)
	}
}